import { render, staticRenderFns } from "./DataListRegions.vue?vue&type=template&id=39cc013d&scoped=true&"
import script from "./DataListRegions.vue?vue&type=script&lang=js&"
export * from "./DataListRegions.vue?vue&type=script&lang=js&"
import style0 from "./DataListRegions.vue?vue&type=style&index=0&id=39cc013d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc013d",
  null
  
)

export default component.exports